import { render, staticRenderFns } from "./ReportSalesDetails.vue?vue&type=template&id=237b157e&scoped=true&"
import script from "./ReportSalesDetails.vue?vue&type=script&lang=js&"
export * from "./ReportSalesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReportSalesDetails.vue?vue&type=style&index=0&id=237b157e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b157e",
  null
  
)

export default component.exports